import React from "react"
import { Form } from "react-bootstrap"
import * as styles from "./style.module.scss"

interface AddonSwitchProps {
  id: string
  bucket: string
  checked: boolean
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  className?: string
}

const AddonSwitch = ({ id, bucket, checked, onChange, className }: AddonSwitchProps) => (
  <div className={`${styles.addonSwitch} ${className || ""}`.trim()}>
    <Form.Check type="switch" name={bucket}>
      <Form.Check.Input id={id} checked={checked} onChange={onChange} />
    </Form.Check>
  </div>
)

export default AddonSwitch
